import AppConfigStore from './AppConfigStore'

export default AppConfigStore
